import { no as unitTest } from './test.text.json';
import { no as header } from '../features/Navigation/Header.text.json';
import { no as shortcut } from '../features/Navigation/Shortcutbar.txt.json';
import { no as innmelding } from '../features/Innmelding/Innmelding.text.json';
import { no as landingsside } from '../features/Landingsside/Landingsside.text.json';
import { no as toast } from '../features/Common/Toast/toast.txt.json';
import { no as dtInput } from '../features/DatetimeInput/DatetimeInput.txt.json';
import { no as kartlag } from '../features/Kartlag/Kartlag.txt.json';
import { no as statistikk } from '../features/Statistikk/Statistikk.text.json';
import { no as antallKontroller } from '../features/AntallKontroller/antallKontroller.txt.json';
import { no as kontrollpanel } from '../features/Kontrollpanel/Kontrollpanel.text.json';
import { no as breadCrumbs } from '../features/Breadcrumb/breadcrumbs.txt.json';
import { no as feiltyper } from '../features/Feiltyper/Feiltyper.txt.json';
import { no as tiltaktyper } from '../features/Tiltaktyper/Tiltaktyper.txt.json';
import { no as entreprenorkontrollMap } from '../features/Driftskart/EntreprenorkontrollMap.text.json';
import { no as roller } from '../features/Admin/Roller.text.json';
import { no as kalenderPeriodeVelger } from '../features/KalenderPeriodeVelger/KalenderPeriodeVelger.txt.json';
import { no as unauth } from '../features/Common/Unauthorized.txt.json';
import { no as dirty } from '../features/Driftskart/MapIsDirtyIndikator.txt.json';
import { no as varslinger } from '../features/Varslinger/Varslinger.text.json';
import { no as statistikkMeldinger } from '../features/Dashboard/Components/Meldinger.text.json';

export default {
  ...unitTest,
  ...header,
  ...shortcut,
  ...innmelding,
  ...landingsside,
  ...toast,
  ...dtInput,
  ...kartlag,
  ...statistikk,
  ...antallKontroller,
  ...kontrollpanel,
  ...breadCrumbs,
  ...feiltyper,
  ...tiltaktyper,
  ...entreprenorkontrollMap,
  ...roller,
  ...kalenderPeriodeVelger,
  ...unauth,
  ...dirty,
  ...varslinger,
  ...statistikkMeldinger,
};
